import React, { useEffect } from "react";
import Landing from "@/pages/Landing";

/**
 * Facebook Ads landing variant.
 *
 * Same Landing UI/structure as `/`, but accessed at `/oferta-fb`.
 * Differences vs `/`:
 *   • UTM auto-attribution: utm_source=facebook, utm_medium=cpc when missing
 *     (handled inside lib/utm.js via path detection).
 *   • Distinct route lets you split FB Ads traffic from organic in GA4 + Hotmart
 *     metadata + payment_transactions, without changing the visual offer.
 *   • Override page title for stronger ad-relevance signals.
 *
 * Once the offer is validated with real data, this file can diverge
 * (different hero copy, simpler funnel, FB-only bonuses, etc.).
 */
export default function OfertaFB() {
  useEffect(() => {
    document.title =
      "Pequeños Platos · Oferta especial USD 9.90 — Ebook + 4 bonos";
  }, []);
  return <Landing />;
}
